export default "__VITE_ASSET__CtwUe5oB__"